module.exports = __webpack_public_path__ + "media/In The Lead Sticker.882a100c.mp3";